import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './Quote.css'
import template from './Quote.jinja'


var Quote = BaseView.extend({
    initialize () {
    },

    playIn(options) {
        this.$el.velocity('stop', true)

        return $.Velocity.animate(this.$el[0], {opacity: 1}, _.extend({
            duration: 1500,
            display: 'block'
        }, options))
    },

    playOut(options) {
        this.$el.velocity('stop', true)

        return $.Velocity.animate(this.$el[0], {opacity: 0}, _.extend({
            duration: 1500,
            display: 'none'
        }, options))
    }
})

export default Quote


// WEBPACK FOOTER //
// ./assets/app/front/components/Quote/Quote.js